import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing'; 

const _productName: string = Licensing.Products.Internal.OPERATIONS_MANAGER;
const _baseUrl: string = Licensing.PRODUCT_ROUTES.get(_productName);

export const OPERATIONS_MANAGER_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: _productName,
	route: _baseUrl,
	sidenav: {
		productName: _productName,
		sections: [
			{
				items: [
					{
						display: 'Home',
						route: `/${_baseUrl}`,
						icon: 'faHome',
					},
					{
						display: 'Cloud Relay Servers',
						route: `/${_baseUrl}/cloud-relay-servers`,
						icon: 'faServer',
					},
					{
						display: 'Customers',
						route: `/${_baseUrl}/customers`,
						icon: 'faUser',
						linkedRoutes: [`/${_baseUrl}/customers/edit/:id`]
					},
					{
						display: 'Customer Servers',
						route: `/${_baseUrl}/customer-servers`,
						icon: 'faUserCog',
						linkedRoutes: [`/${_baseUrl}/customer-servers/edit/:id`]
					}
				]
			}
		]
	}
};
